import {
  Box,
  chakra,
  Container,
  Stack,
  Text,
  useColorModeValue,
  VisuallyHidden,
} from "@chakra-ui/react";
import {
  FaGithub,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { ReactNode } from "react";
import Logo from "../Logo";
import { Link } from "react-router-dom";

const SocialButton = ({ children, label, href }) => {
  return (
    <chakra.button
      bg={useColorModeValue("blackAlpha.100", "whiteAlpha.100")}
      rounded={"full"}
      w={8}
      h={8}
      cursor={"pointer"}
      as={"a"}
      href={href}
      target='_blank'
      display={"inline-flex"}
      alignItems={"center"}
      justifyContent={"center"}
      transition={"background 0.3s ease"}
      _hover={{
        bg: useColorModeValue("blackAlpha.200", "whiteAlpha.200"),
      }}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

export default function Footer() {
  return (
    <Box bg={useColorModeValue("#000")} color={useColorModeValue("#FFF")}>
      <Container
        as={Stack}
        maxW={"6xl"}
        py={4}
        spacing={4}
        justify={"center"}
        align={"center"}
      >
        <Logo />
        <Stack direction={"row"} spacing={6}>
          <Link to={"/"}>Home</Link>
          <Link to={"/about"}>About me</Link>
          <Link to={"/projects"}>Projects</Link>
          {/* <Link to={"#"}>Testimonial</Link> */}
          <Link to={"/contact"}>Contact</Link>
        </Stack>
      </Container>

      <Box
        borderTopWidth={1}
        borderStyle={"solid"}
        borderColor={useColorModeValue("gray.200", "gray.700")}
      >
        <Container
          as={Stack}
          maxW={"6xl"}
          py={4}
          direction={{ base: "column", md: "row" }}
          spacing={4}
          justify={{ base: "center", md: "space-between" }}
          align={{ base: "center", md: "center" }}
        >
          <Text textAlign={"center"}>
            Copyright © {1900 + new Date().getYear()} Naol Kefyalew. • Full
            Stack Developer
          </Text>
          <Stack direction={"row"} spacing={6}>
            <SocialButton
              label={"Linkendin"}
              href={"https://www.linkedin.com/in/naol-kefyalew-72446b205/"}
            >
              <FaLinkedin size='1.15rem' />
            </SocialButton>
            <SocialButton label={"Github"} href={"https://github.com/naolk"}>
              <FaGithub size='1.15rem' />
            </SocialButton>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}
